import Sprite from "./Sprite";
import SpriteAnimationManager from "./SpriteAnimationManager";

export default class SpriteAnimation {
    /**
     * @param {Array.<Sprite>} sprites
     * @param {SpriteAnimationManager} spriteAnimationManager
     * @param {boolean} fastAnimation
     * @param {boolean} loopingAnimation
     */
    constructor(sprites, spriteAnimationManager, fastAnimation, loopingAnimation) {
        /**
         * @private
         * @constant
         * @type {Array.<Sprite>}
         */
        this.sprites = sprites;        
        /**
         * @private
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * @private
         * @constant
         * @type {boolean}
         */
        this.fastAnimation = fastAnimation;
        /**
         * @private
         * @constant
         * @type {boolean}
         */
        this.loopingAnimation = loopingAnimation; 
    }

    // /**
    //  * @returns {Sprite}
    //  */
    // getSprite() {
    //     return this.getCurrentSpriteDefault();
    // }

    /**
     * @param {number} currentTime 
     * @param {number} startTime 
     * @returns {Sprite}
     */
    getSpriteAsOf(currentTime, startTime) {

        if (this.sprites.length === 1) {
            return this.sprites[0];
        }

        if (this.fastAnimation) {
            return this.getFastCurrentSpriteAsOf(currentTime, startTime);
        }
        else {
            return this.getCurrentSpriteAsOf(currentTime, startTime);
        }
        //return this.getCurrentSpriteDefault();
    }

    /**
     * @param {number} frameIndex 
     * @returns {Sprite}
     */
    getSpriteAtIndex(frameIndex) {
        if (frameIndex < 0 || frameIndex >= this.sprites.length) {
            return null;
        }
        return this.sprites[frameIndex];
    }
    
    /**
     * @returns {Sprite}
     */
    getCurrentSpriteDefault() {
        // This version of sprite animation is for the dawnlike sprites and has to loop.
        const frameIndex = this.spriteAnimationManager.getDefaultFrameIndex(this.sprites.length);
        return this.sprites[frameIndex];
    }
    /**
     * @param {number} currentTime
     * @param {number} startTime
     * @returns {Sprite}
     */
    getCurrentSpriteAsOf(currentTime, startTime) {

        const frameIndex = this.spriteAnimationManager.getFrameIndex(currentTime, startTime, this.sprites.length, this.loopingAnimation);
        if (frameIndex < 0) {
            return null;
        }

        return this.sprites[frameIndex];
    }
    /**
     * @param {number} currentTime
     * @param {number} startTime
     * @returns {Sprite}
     */
    getCurrentSpriteAsOfNoLooping(currentTime, startTime) {

        const frameIndex = this.spriteAnimationManager.getFrameIndex(currentTime, startTime, this.sprites.length, false);
        if (frameIndex < 0) {
            return null;
        }

        return this.sprites[frameIndex];
    }
    /**
     * @param {number} currentTime
     * @param {number} startTime
     * @returns {Sprite}
     */
    getSlowCurrentSpriteAsOfNoLooping(currentTime, startTime) {

        const frameIndex = this.spriteAnimationManager.getSlowFrameIndex(currentTime, startTime, this.sprites.length, false);
        if (frameIndex < 0) {
            return null;
        }

        return this.sprites[frameIndex];
    }
    /**
     * @param {number} currentTime
     * @param {number} startTime
     * @returns {Sprite}
     */
    getFastCurrentSpriteAsOf(currentTime, startTime) {
        const frameIndex = this.spriteAnimationManager.getFastFrameIndex(currentTime, startTime, this.sprites.length, this.loopingAnimation);
        if (frameIndex < 0) {
            return null;
        }
        return this.sprites[frameIndex];
    }
    /**
     * @param {number} currentTime
     * @param {number} startTime
     * @returns {Sprite}
     */
    getSuperFastCurrentSpriteAsOf(currentTime, startTime) {
        const frameIndex = this.spriteAnimationManager.getSuperFastFrameIndex(currentTime, startTime, this.sprites.length, this.loopingAnimation);
        if (frameIndex < 0) {
            return null;
        }
        return this.sprites[frameIndex];
    }

    /**
     * @param {number} startTime 
     * @returns {boolean}
     */
    isAnimationLoopCompleted(startTime) {
        if (this.fastAnimation) {
            return this.spriteAnimationManager.isFastAnimationLoopCompleted(Date.now(), startTime, this.sprites.length);
        }
        else {
            return this.spriteAnimationManager.isDefaultAnimationLoopCompleted(Date.now(), startTime, this.sprites.length);
        }
    }

    /**
     * @param {number} spriteDirection  See: SpriteDirection.js
     * @returns {Sprite}
     */
    getDirectionSprite(spriteDirection) {
        return this.sprites[spriteDirection];
    }

    /**
     * @returns {boolean}
     */
    isDirectionalSprite() {
        return false;
    }

}